import { render } from "./BachelorsFilterContainer.vue?vue&type=template&id=1a8f10c5&ts=true"
import script from "./BachelorsFilterContainer.ts?vue&type=script&lang=ts&external"
export * from "./BachelorsFilterContainer.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__